import { SET_IS_AUTHORIZED } from '@app/actions/_types';

const initialAuthState = {
  isAuthorized: false,
};

export default (state = initialAuthState, { type, payload } = {}) => {
  if (type === SET_IS_AUTHORIZED) {
    return { ...state, isAuthorized: payload };
  }
  return state;
};
